import React from "react";
import { Button, DynamicButton, StyledText } from "../../../../components/common";
import { BackIcon, CloseIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import CupIcon from "../images/cup.png";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  img {
    width: 80px;
  }
`;

const modalInfo = [
  `Opt in to start building points by mashing up and stand a chance to win amazing prizes!`,
  `Build points and ranking in the top percentage to participate in the Capture.`,
  `Capture an image from the fast displaying GIF to Capture and win a prize.`,
]

const OptInRequestModal = ({ isOpen, onClose }) => {
  const { themeContext, theme } = useTheme();
  const history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  if (!isOpen) return null;

  const optIn = () => {
    onClose(true)
    history.push('/capturenshare')
  }

  const optOut = () => {
    onClose(false)
  }

  return (
    <>
      <ModalOverlay onClick={() => { }} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div style={{
          position: "relative",
          width: "100%",
          textAlign: "center"
        }}
        >
          <div
            style={{
              width: 50,
              height: 8,
              backgroundColor: "#cbcbcb",
              borderRadius: 10,
              position: "absolute",
              top: "-5px",
              left: "0%",
              right: "0%",
              margin: "0 auto",
            }}
            onClick={() => { }}
          />
          <Header>
            <CloseButton onClick={() => { }}>
              <CloseIcon width={18} />
            </CloseButton>
          </Header>

          <StyledText style={{ fontSize: 24, marginTop: 0 }}>Capture &amp; Share</StyledText>
          <div style={{ maxWidth: "300px", margin: "0 auto" }}>
            <IconContainer>
              <img src={CupIcon} alt="cup" />
            </IconContainer>
            {
              modalInfo.map((val, idx) =>
                <div style={{ display: "flex", }}>
                  <div>
                    <div
                      style={{ marginTop: "4px", width: "16px", height: "16px", borderRadius: "32px", backgroundColor: "#FFCC00" }}></div>
                  </div>
                  <StyledText
                    key={idx}
                    style={{
                      textAlign: "left",
                      fontFamily: "MTNRegular",
                      fontSize: "14px",
                      paddingInline: 15,
                      margin: 0,
                      marginBottom: "18px"
                    }}
                  >
                    {val}
                  </StyledText>
                </div>
              )
            }
            <DynamicButton
              color="#FFCC00"
              textColor="#000"
              label="Opt in"
              fullWidth
              onClick={optIn}
            />
            <DynamicButton
              color="#000"
              textColor="#000"
              label="Not interested"
              variant="outlined"
              fullWidth
              onClick={optOut}
            />
          </div>
        </div>
      </ModalContent >
    </>
  );
};

export default OptInRequestModal;
